import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';

export function createCtx() {
    
    const ctx = React.createContext(undefined);
    function useCtx() {
        const c = React.useContext(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [useCtx, ctx.Provider];
}

export const [useRootContext, CtxProvider] = createCtx();

export const RsvpContext = ({ children, ...props }) => {
    const [registerContext, setRegisterContext] = useState({});
    const [rsvpContext, setRsvpContext] = useState({});
    const [dataContext, setDataContext] = useState({});
    const [scheduleContext, setScheduleContext] = useState([]);
    
    const getRegisteredRooms = () => {
        if (!dataContext.rooms) return [];
        let registeredRooms = [...dataContext.rooms];
        return registeredRooms.filter(function (room) {
            return room.room_type.value == 'main_stage' || (room.registered && room.room_type.value == 'breakout');
        }).sort(
            (a, b) =>{
                return moment(a.start).format('YYYYMMDDHHMM') - moment(b.start).format('YYYYMMDDHHMM')
            });
    };

    useEffect(() => {
        const currentRegister = props.initalRegisterValue;
        setRegisterContext(currentRegister);
        const currentRsvp = props.initalRsvpValue;
        setRsvpContext(currentRsvp);
        const currentDataContext = props.initialDataSource;
        setDataContext(currentDataContext);
        const currentScheduleContext = getRegisteredRooms();
        setScheduleContext(currentScheduleContext);
    }, []);

    useEffect(() => {
        const currentScheduleContext = getRegisteredRooms();
        setScheduleContext(currentScheduleContext);
    }, [dataContext.rooms]);

    return (
        <CtxProvider
            value={{
                rsvpContext,
                setRsvpContext,
                registerContext,
                setRegisterContext,
                dataContext,
                setDataContext,
                scheduleContext,
                setScheduleContext
            }}
        >
            {children}
        </CtxProvider>
    );
};
